import { render, staticRenderFns } from "./open-link.vue?vue&type=template&id=4ab60d16&scoped=true"
import script from "./open-link.vue?vue&type=script&lang=js"
export * from "./open-link.vue?vue&type=script&lang=js"
import style0 from "./open-link.vue?vue&type=style&index=0&id=4ab60d16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab60d16",
  null
  
)

export default component.exports